import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import { Pencil, Plus, Trash2, Users2 } from "lucide-react";
import { emptyCustomer } from "../lib/invoice";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const FIELDS = [
  ["name", "Ünvan"],
  ["address", "Adres"],
  ["phone", "Telefon"],
  ["trn", "TRN"],
  ["web", "Web"],
  ["email", "E-posta"],
];

export default function InvoiceCustomers() {
  const [customers, setCustomers] = useState([]);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(emptyCustomer);
  const [notice, setNotice] = useState("");

  const load = useCallback(() => axios.get(`${API}/invoices/customers`).then(r => setCustomers(r.data)), []);
  useEffect(() => { load().catch(() => {}); }, [load]);

  const save = async event => {
    event.preventDefault();
    try {
      if (editing?.id) await axios.put(`${API}/invoices/customers/${editing.id}`, form);
      else await axios.post(`${API}/invoices/customers`, form);
      setEditing(null);
      setNotice("Müşteri kaydedildi");
      await load();
    } catch (e) {
      setNotice(e?.response?.data?.detail || "Kaydedilemedi");
    }
  };

  const remove = async customer => {
    try {
      await axios.delete(`${API}/invoices/customers/${customer.id}`);
      setNotice(`Müşteri silindi: ${customer.name}`);
      await load();
    } catch (e) {
      setNotice(e?.response?.data?.detail || "Silinemedi");
    }
  };

  const open = customer => {
    setForm(customer ? { ...emptyCustomer(), ...customer } : emptyCustomer());
    setEditing(customer || {});
    setNotice("");
  };

  return (
    <section className="panel invoice-customers" data-testid="invoice-customers">
      <div className="panel-head">
        <div>
          <p className="eyebrow">FATURA MÜŞTERİLERİ</p>
          <h3>Kayıtlı müşteriler</h3>
        </div>
        <Users2 size={18}/>
      </div>
      <button className="outline-btn" data-testid="add-invoice-customer" onClick={() => open(null)}><Plus size={15}/> Müşteri ekle</button>
      <div className="group-chips" data-testid="invoice-customer-chips">
        {customers.map(customer => (
          <span key={customer.id} className="group-tag income" data-testid={`invoice-customer-${customer.name}`}>
            {customer.name}
            <button type="button" className="chip-btn" title="Düzenle" data-testid={`edit-invoice-customer-${customer.name}`}
              onClick={() => open(customer)}><Pencil size={11}/></button>
            <button type="button" className="chip-btn danger" title="Sil" data-testid={`delete-invoice-customer-${customer.name}`}
              onClick={() => remove(customer)}><Trash2 size={11}/></button>
          </span>
        ))}
      </div>
      {!customers.length && <small className="hint">Henüz kayıtlı müşteri yok. Fatura keserken "kayıtlı müşteri listesine ekle" seçeneğiyle de eklenir.</small>}
      {notice && <small className="group-notice" data-testid="invoice-customer-notice">{notice}</small>}

      <Dialog open={!!editing} onOpenChange={value => !value && setEditing(null)}>
        <DialogContent data-testid="invoice-customer-dialog">
          <DialogHeader><DialogTitle>{editing?.id ? "Müşteriyi düzenle" : "Müşteri ekle"}</DialogTitle></DialogHeader>
          <form className="edit-form" onSubmit={save}>
            {FIELDS.map(([key, label]) => (
              <div className="field" key={key}>
                <label>{label}</label>
                <input required={key === "name"} data-testid={`invoice-customer-${key}-input`} value={form[key] || ""}
                  onChange={e => setForm(current => ({ ...current, [key]: e.target.value }))}/>
              </div>
            ))}
            <div className="dialog-actions">
              <button type="button" className="outline-btn" data-testid="invoice-customer-cancel" onClick={() => setEditing(null)}>Vazgeç</button>
              <button type="submit" className="primary-btn" data-testid="invoice-customer-save">Kaydet</button>
            </div>
          </form>
        </DialogContent>
      </Dialog>
    </section>
  );
}
